<template>
  <div class="app">
    <Card dis-hover>
      <Form
        :model="query"
        :label-width="90"
        label-position="right"
        style="margin: 10px"
      >
        <Row :gutter="16">
          <Col span="6">
            <FormItem label="产线:" :label-width="40" style="width: 100%">
              <Select placeholder="请选择产线" v-model="query.ProductionLineName" >
                <Option value="">------</Option>
                <Option v-for="item in productionLineList" :key="item.value" :value="item.value" >
                  {{ item.name }}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="供应商名称：">
              <Input v-model="query.SupplierName" placeholder="请输入供应商名称" ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="受单日期:" style="width: 100%">
              <DatePicker v-model="rangeTime" type="daterange" format="yyyy-MM-dd" style="width: 100%" placement="bottom-end" placeholder="请选择受单日期" ></DatePicker> 
            </FormItem>
          </Col>
          <Button icon="ios-search" type="primary"  size="default" @click="getInit" class="toolbar-btn" >统计</Button>
          <Button @click="exportFile" icon="md-archive" type="primary" size="default" class="toolbar-btn" >{{ "导出" }}</Button >
        </Row>
      </Form>
      <div class="table-cont">
        <div class="table-item">
          <Table :columns="columnsProduction" no-data-text="暂无数据" border :data="listProduction"> </Table>
        </div>
        <div class="table-item">
          <Table :columns="columnsSupplier" no-data-text="暂无数据" border :data="listSupplier"> </Table>
        </div>
      </div>
    </Card>
    <Spin fix v-show="loading">
      <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
      <div>加载中</div>
    </Spin>
  </div>
</template>

<script>
import moment from "moment";
import Util from "../../../lib/util";

export default {
  name: "timeliness",
  data() {
    return {
      query: {
        ProductionLineName: "",
        SupplierName:"",
        StartTime: "",
        EndTime: "",
      },
      rangeTime: [],
      columnsProduction:[],
      columnsSupplier:[],
      listProduction:[],
      listSupplier:[],
      productionLineList: [],
      loading: false,
    };
  },
  mounted() {
    this.getNowDate()
    this.getColumns();
    this.getInfo();
    this.getInit();
  },
  methods: {
    async getInit() {
      this.loading = true;
      if (this.rangeTime[0]) {
        this.query.StartTime = moment(this.rangeTime[0]).format("YYYY-MM-DD");
      }
      if (this.rangeTime[1]) {
        this.query.EndTime = moment(this.rangeTime[1]).format("YYYY-MM-DD");
      }
      if (!this.rangeTime[0]) {
        this.query.StartTime = "";
      }
      if (!this.rangeTime[1]) {
        this.query.EndTime = "";
      }
      const result = await this.$Ajax( "/api/services/app/GZBDataItem/GetAmountOfProductionLineAndSupplier", { params: this.query } );
      console.log(result)
      this.listProduction = result.data.result.amountOfProductionLineData
      this.listSupplier = result.data.result.amountOfSupplierModelData
      this.loading = false;
    },
    async getInfo() {
      const result = await this.$Ajax( "/api/services/app/GZBDataItem/GetMgrInitData" );
      this.productionLineList = result.data.result.productionLineList;
    },
    getNowDate(){
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth()
      this.rangeTime = [new Date(year,month,1),new Date()]
    },
    getColumns(){
      this.columnsProduction = [
        {
          title:'产线',
          key:'productionLineName',
          minWidth:100
        },
        {
          title:'总金额/元',
          key:'totalAmount',
          minWidth:100
        }
      ]
      this.columnsSupplier = [
        {
          title:'供应商',
          key:'supplierName',
          minWidth:100
        },
        {
          title:'总金额/元',
          key:'totalAmount',
          minWidth:100
        }
      ]
    },
    exportFile() {
      if (this.rangeTime[0]) {
        this.query.StartTime = moment(this.rangeTime[0]).format("YYYY-MM-DD");
      }
      if (this.rangeTime[1]) {
        this.query.EndTime = moment(this.rangeTime[1]).format("YYYY-MM-DD");
      }
      if (!this.rangeTime[0]) {
        this.query.StartTime = "";
      }
      if (!this.rangeTime[1]) {
        this.query.EndTime = "";
      }
      const date = moment(new Date()).format("yyyyMMDDHHmm");
      let _this = this;
      let consturl = `${this.$constDefinition.baseUrl}/api/Export/ExportAmountOfProductionLineAndSupplier?ProductionLineName=${this.query.ProductionLineName}&SupplierName=${this.query.SupplierName}&StartTime=${this.query.StartTime}&EndTime=${this.query.EndTime}`; //下载地址url
      var xhr = new XMLHttpRequest();
      xhr.open("get", consturl, true); // get、post都可
      xhr.responseType = "blob";
      xhr.setRequestHeader(
        "Authorization",
        `Bearer ${Util.abp.auth.getToken()}`
      ); //加请求头
      xhr.onload = function () {
        console.log(xhr);
        if (xhr.status == 200) {
          let blob = new Blob([this.response], {
            type: "application/vnd.ms-excel",
          });
          var a = document.createElement("a");
          var url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = `产线金额统计报表${date}.xlsx`; // 文件名
          if (xhr.readyState === 4) {
            _this.$Message.success({
              content: "下载成功",
            });
          }
        } else {
          _this.$Message.error({
            content: "下载失败",
          });
        }
        a.click();
        window.URL.revokeObjectURL(url);
      };
      xhr.send();
    },
  },
};
</script>

<style lang="less" scoped>
.app {
  min-width: 900px;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}


.table-cont {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.table-cont .table-item{
  width: 50%;
  margin-right: 20px;
}

.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

</style>
